import React from 'react';
import DarkMarketingPage from '../Shared/DarkMarketingPage';
import Group109 from '../../../images/marketing/webHosting/Group109.png';
import Group107 from '../../../images/marketing/webHosting/Group107.png';

const sections = [
  {
    label: 'INFRASTRUCTURE',
    title: 'Secure Servers',
    description:
      'Making sure your website is run safely is what we do best. Launch secure hosting quickly and keep your website protected.',
    link: '/webhosting',
    image: Group109,
  },
  {
    label: 'SCALING',
    title: 'Handling Demand',
    description:
      'When your website needs more bandwidth, we autoscale your system to handle demand so you can focus on growth.',
    link: '/webhosting',
    image: Group107,
    reverse: true,
  },
];

const quickTags = [
  'Secure Hosting',
  'Auto Scaling',
  'Reliable Uptime',
  'Traffic Handling',
  'Fast Deployment',
  'Built for Growth',
];

const WebHostingContent = ({ history }) => (
  <DarkMarketingPage
    history={history}
    title="EditPage Web Hosting"
    subtitle="EditPage has server hosting that lets you focus on growing your business while we manage uptime and security."
    sections={sections}
    quickTags={quickTags}
  />
);

export default WebHostingContent;
